import React, { useEffect, useState } from "react";
import Button from "../../../components/elements/button";
import { useParams } from "react-router-dom";
import SidebarMCdetails from "./sidebarMCdetails";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import { AgGridReact } from "ag-grid-react";

interface Attachment {
  fileName: string;
  uploadedBy: string;
  uploadedDate: string;
}

const CalendarMP: React.FC = () => {
  const params: any = useParams();
  const [tab, setTab] = useState<string>("unassigned");

  const columnDefs = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      width: 50,
      headerClass: "bg-[#f0f0f0]",
    },
    {
      headerName: "Schedule No",
      field: "workOrderCode" as const,
      headerClass: "bg-[#f0f0f0]",
      width: 160,
      cellRenderer: () => {
        return (
          <p className="hover:text-primary font-semibold cursor-pointer">
            Lorem
          </p>
        );
      },
      // onCellClicked: (param: any) => {
      //   navigate(URLS.WORK_ORDER_DETAILS(param.data.workOrderID));
      // },
    },

    {
      headerName: "Scheduler Type",
      field: "description" as const,
      headerClass: "bg-[#f0f0f0]",
      width: 140,
      flex: 1,
      cellRenderer: () => {
        return (
          <p className="hover:text-primary font-semibold cursor-pointer">
            Lorem
          </p>
        );
      },
    },
    {
      headerName: "Priority",
      field: "priorityName" as const,
      headerClass: "bg-[#f0f0f0]",
      width: 160,
      cellRenderer: () => {
        return (
          <p className="hover:text-primary font-semibold cursor-pointer">
            Lorem
          </p>
        );
      },
    },
    {
      headerName: "Facility",
      field: "facilityName" as const,
      headerClass: "bg-[#f0f0f0]",
      minWidth: 160,
      cellRenderer: () => {
        return (
          <p className="hover:text-primary font-semibold cursor-pointer">
            Lorem
          </p>
        );
      },
      // tooltipValueGetter: (params: any) => {
      //   return (
      //     params.data.facilityName +
      //     (params.data.subFacilityName
      //       ? `, ${params.data.subFacilityName}`
      //       : "")
      //   );
      // },
    },
    {
      headerName: "Start Date",
      field: "startDate" as const,
      headerClass: "bg-[#f0f0f0]",
      width: 140,
      cellStyle: { textAlign: "center" },
      cellRenderer: () => {
        return (
          <p className="hover:text-primary font-semibold cursor-pointer">
            Lorem
          </p>
        );
      },
    },
    {
      headerName: "End Date",
      field: "endDate" as const,
      headerClass: "bg-[#f0f0f0]",
      width: 140,
      cellRenderer: () => {
        return (
          <p className="hover:text-primary font-semibold cursor-pointer">
            Lorem
          </p>
        );
      },
    },
    {
      headerName: "Status",
      field: "woStatusName" as const,
      headerClass: "bg-[#f0f0f0]",
      width: 200,
      cellRenderer: () => {
        return (
          <p className="hover:text-primary font-semibold cursor-pointer">
            Lorem
          </p>
        );
      },
    },
  ];

  const rowData = [
    {
      "workOrderID": 41,
      "workRequestID": 0,
      "facilityID": 100,
      "facilityName": "Mumbai Test Facility 01 ",
      "priorityID": 4,
      "priorityName": "Preventative",
      "woGrowerID": 0,
      "woGrowerName": null,
      "woVendorID": 0,
      "woVendorName": null,
      "woAssignmentTypeID": 0,
      "woAssignmentTypeName": null,
      "woMaintenanceTypeID": 0,
      "woMaintenanceTypeName": null,
      "departmentID": 0,
      "departmentName": null,
      "woStatusID": 3,
      "woStatusName": "Canceled",
      "facilityCode": "ARF1745997851",
      "subFacilityID": null,
      "subFacilityName": null,
      "workOrderCode": "WO1751017497",
      "woStatusHexCode": "#FBAD1C",
      "startDate": null,
      "originalStartDate": null,
      "endDate": null,
      "originalEndDate": "2025-06-27T09:51:17.863",
      "description": "kjbhgfhjk",
      "notes": "",
      "progressStatusNote": null,
      "addedBy": 5,
      "addedDate": "0001-01-01T00:00:00",
      "modifiedBy": null,
      "modifiedDate": null,
      "addedByName": "Jane  Doe"
    },
    {
      "workOrderID": 40,
      "workRequestID": 0,
      "facilityID": 100,
      "facilityName": "Mumbai Test Facility 01 ",
      "priorityID": 2,
      "priorityName": "Immediate flock performance impact",
      "woGrowerID": 0,
      "woGrowerName": null,
      "woVendorID": 0,
      "woVendorName": null,
      "woAssignmentTypeID": 1,
      "woAssignmentTypeName": "R&M",
      "woMaintenanceTypeID": 0,
      "woMaintenanceTypeName": null,
      "departmentID": 0,
      "departmentName": null,
      "woStatusID": 2,
      "woStatusName": "Scheduled",
      "facilityCode": "ARF1745997851",
      "subFacilityID": null,
      "subFacilityName": null,
      "workOrderCode": "WO1751011493",
      "woStatusHexCode": "#556EE6",
      "startDate": "2025-06-27T09:44:01",
      "originalStartDate": null,
      "endDate": "2025-06-27T09:46:01",
      "originalEndDate": null,
      "description": "hgcxchfgjklhgjch",
      "notes": "",
      "progressStatusNote": null,
      "addedBy": 5,
      "addedDate": "0001-01-01T00:00:00",
      "modifiedBy": null,
      "modifiedDate": null,
      "addedByName": "Jane  Doe"
    },]

  return (
    <div>
      <FullCalendar
        plugins={[dayGridPlugin]}
        initialView="dayGridMonth"
        headerToolbar={{
          start: "today,prev,next",
          center: "title",
          end: "dayGridMonth,dayGridWeek,dayGridDay",
        }}
      />

      <div>
        <div className="px-5 border-b border-gray-200 h-[3.75rem] flex items-center gap-[2.188rem] text-gray-600 text-[0.938rem] font-medium relative">
          <button
            className={`hover:text-black relative flex h-full items-center ${
              tab == "unassigned"
                ? "text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1"
                : ""
            }`}
            onClick={() => setTab("unassigned")}
          >
            Unassigned
          </button>
          <button
            className={`hover:text-black relative flex h-full items-center ${
              tab == "planned-maintenance"
                ? "text-black  before:border-b-2 before:bg-primary before:absolute before:w-full before:h-1 before:-bottom-1"
                : ""
            }`}
            onClick={() => {
              setTab("planned-maintenance");
            }}
          >
            Planned Maintenance
          </button>
        </div>

        <div
          className="px-5"
          style={{ maxHeight: `calc(100vh - 120px)`, overflowY: `auto` }}
        >
          <div className="ag-theme-alpine px-4 w-full h-1/2">
            <AgGridReact
              columnDefs={columnDefs} // Pass columnDefs
              rowData={rowData} // Pass rowData
              rowSelection="multiple"
              // onGridReady={onGridReady}
              pagination={false}
              domLayout="autoHeight"
              // onRowClicked={onRowClicked}
              // loadingOverlayComponent={Loader}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarMP;
